import { request } from 'umi';
import { paramsSerializer } from './api';

/** 
 * Get users list
 * 
 *  GET /api/users-list */
export async function users(params: API.PageParams, sort: any, filter: any) {
  return request<API.BaseResult>('/api/users-list', {
    method: 'GET',
    params: {
      ...params,
      perPage: params.pageSize,
      page: params.current,
      // sort_fields: Object.keys(sort).join(','),
      // sort_dirs: Object.values(sort).join(','),
      sort_detail: JSON.stringify(sort),
      filter_detail: JSON.stringify(filter),
    },
    withToken: true,
    paramsSerializer,
  }).then((res) => ({
    data: res.message.data,
    success: res.status == 'success',
    total: res.message.pagination.totalRows,
  }));
}
export async function getUsersList(params: API.PageParams, sort?: any, filter?: any) {
  return users(params, sort, filter);
}

/** Put PUT /api/users */
export async function updateUser(data: API.UserListItem, options?: { [key: string]: any }) {
  return request<API.UserListItem>('/api/users/' + data.id, {
    method: 'PUT',
    data: data,
    ...(options || {}),
  });
}

/** Put PUT /api/users/change-password */
export async function changeUserPassword(data: API.UserListItem, options?: { [key: string]: any }) {
  return request<API.UserListItem>(`/api/users/change-password`, {
    method: 'PUT',
    data: data,
    ...(options || {}),
  });
}

/** post POST /api/users-list */
export async function addUser(data: API.UserListItem, options?: { [key: string]: any }) {
  return request<API.UserListItem>('/api/users-list', {
    method: 'POST',
    data: data,
    ...(options || {}),
  });
}

/** delete DELETE /api/rule */
export async function removeUser(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/users-list/' + (options ? options['user_id'] : ''), {
    method: 'DELETE',
    ...(options || {}),
  });
}
